import React from 'react';
import { Col, Row } from 'antd';
import { TextSmall } from '../../../../components';
import { IconContainerDiv, StatusColumnContainer } from '../../../../styles/global-style';
import { StepIcon } from '../../../../resources';
import { requestStatusObg2 } from '../resource/requestStatusObg';
import { PauseOutlined } from '@ant-design/icons';

export const InfoClaimStatus = () => {
  const statusArray = Object.entries(requestStatusObg2);

  return (
    <>
      <Col span={24}>
        <TextSmall bold style={{ textDecoration: 'underline' }}>
          สถานะ
        </TextSmall>
      </Col>
      <Col span={24}>
        <Row align={'middle'} style={{ marginTop: '3px', marginBottom: '3px' }}>
          {statusArray.map(([key, { icon, color, label }], index) => (
            <React.Fragment key={key}>
              <Col>
                <StatusColumnContainer>
                  <IconContainerDiv style={{ color }}>{icon}</IconContainerDiv>
                  <TextSmall>{label}</TextSmall>
                </StatusColumnContainer>
              </Col>
              {index < statusArray.length - 2 && (
                <Col>
                  <StepIcon />
                </Col>
              )}
              {index === statusArray.length - 2 && (
                <Col>
                  <PauseOutlined />
                </Col>
              )}
            </React.Fragment>
          ))}
        </Row>
      </Col>
    </>
  );
};
